<template>
  <div class="template q-px-lg q-py-md">
    <div>
      <div class="q-pb-md">
        <h4>
          O Vega contingêngia deve ser habilitado em condicoes de falha
          sistêmica, que impossibilite o acesso pelo app Nota 10 ou
          indisponibilidade no sistema NETSMS e TOA.
        </h4>
      </div>
      <div class="profile flex row items-center q-mt-sm">
        <!-- <div class="avatar-user q-mr-sm">
          <q-img
            src="https://picsum.photos/500/300"
            width="100%"
            height="100px"
            fit="cover"
          />
        </div> -->
        <div class="flex column flex-start">
          <h3>{{ usuerLogged.nome }}</h3>
          <h4>credenciada: {{ usuerLogged.credenciada }}</h4>
        </div>
      </div>
      <div class="flex row items-center profile">
        <q-form class="" ref="loginForm" @submit.prevent.stop="onSubmit">
          <div class="group-input col-12 row q-mt-sm">
            <label for="os_number">Número do chamado</label>
            <q-input
              id="os_number"
              ref="osNumberRef"
              type="text"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="40"
              color="red-9"
              dense
              outlined
              unmasked-value
              v-model="enableForm.numeroChamado"
              :rules="[(val) => !!val.length || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>

          <div class="submit-btn col-12 row q-mt-sm">
            <label for="os_number">Justificativa</label>
            <q-select
              id="type-os"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="redoDropRef"
              v-model="enableForm.justify"
              color="red-9"
              map-options
              emit-value
              fill-input
              @update:model-value="verifyDrop(requestData.redoFromDrop)"
              :options="justifyList"
              bg-color="white"
              :rules="[(val) => val.length !== '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>
        </q-form>
      </div>
    </div>
    <!-- [
                { label: 'Nota10 Indisponível', value: 1 },
                { label: 'NETSMS Indisponível', value: 2 },
                { label: 'TOA Indisponível', value: 3 },
              ] -->
    <div class="flex column">
      <q-btn
        class="submit-btn q-mt-sm"
        unelevated
        no-caps
        size="md"
        type="submit"
        label="Ativar contigência"
        @click="onSubmit"
        rounded
        color="red-9"
        :loading="btnLoading"
      />
    </div>
  </div>
</template>

<script>
//-----VUEJS
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

//-----QUASAR
import { useQuasar } from "quasar";
//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";

import { enableContigency } from "@/utils/ResquestOsForms/createContigencyAction.js";

export default {
  name: "EnableContingency",
  setup() {
    //----CONSTANTS
    const loginForm = ref(null);
    const justifyList = ref([]);
    const $q = useQuasar();
    const store = useStore();
    const router = useRouter();
    const usuerLogged = store.state.userData;

    //----VARIABLES
    let enableForm = ref({
      username: usuerLogged.usuario,
      justify: "",
      numeroChamado: "",
    });
    let btnLoading = ref(false);
    let contingencyServices = new ContingencyServices();

    async function onSubmit() {
      if (!(await loginForm.value.validate())) {
        $q.notify({
          color: "red-5",
          message: "Você precisa preencher todos os campos obrigatórios",
          position: "top",
        });
        return;
      }

      let data = enableContigency(usuerLogged.usuario, enableForm.value);

      //FUNCTIONS
      await contingencyServices
        .eneableContingency(data)
        .then(async (response) => {
          $q.notify({
            message: "contingencia ativada",
            color: "green-9",
            position: "top",
          });
          btnLoading.value = false;
          router.push({ name: "config-history" });
        })
        .catch((error) => {
          $q.notify({
            message: error.response.data.toString(),
            color: "red-9",
            position: "top",
          });
          btnLoading.value = false;
        });
    }

    async function getJustifyActiveContingency() {
      await contingencyServices
        .getJustifyActiveContingency()
        .then((response) => {
          response.forEach((element) => {
            justifyList.value.push({
              label: element.text,
              value: element.text,
            });
          });
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    onMounted(() => {
      getJustifyActiveContingency();
    });

    return {
      //----VARIABLES
      loginForm,
      enableForm,
      btnLoading,
      justifyList,
      usuerLogged,

      //FUNCTIONS
      onSubmit,
    };
  },
};
</script>
<style lang="scss">
.template {
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #e5e5e5;

  h4 {
    margin: 0;
    color: rgba(0, 0, 0, 0.7);
    font-size: 1rem;
    font-family: Roboto;
    line-height: 18px;
  }

  .profile {
    display: flex;
    align-items: center;
    .avatar-user {
      width: 57px;
      height: 57px;
      border-radius: 9999px;
      overflow: hidden;
    }

    h3 {
      color: rgba(0, 0, 0, 0.7);
      font-size: 1rem;
      font-family: Roboto;
      margin: 0;
      line-height: 18px;
    }

    h4 {
      color: rgba(0, 0, 0, 0.5);
      font-size: 0.875rem;
      font-family: Roboto;
      margin: 0;
      margin: 0;
      line-height: 18px;
    }
  }
}
</style>
